<template>
    <div v-if="!currentProduct.variations[0]">
        <div class="column" align="center">
            <p class="is-size-5 is-uppercase">An diesem Produkt wird noch gearbeitet, bitte versuchen Sie es später noch einmal</p>
        </div>
    </div>
    <div v-else class="product-informations" ref="top">
        <div class="columns">
            <div class="column is-8">
                <div class="has-text-grey is-size-3">Ihr konfiguriertes Produkt</div>
                <div class="has-text-weight-bold is-size-4" v-if="categorySchraubenart">{{ categorySchraubenart.name }} </div>
                <div class="gap-2" />
                <div class="has-text-primary has-text-weight-bold is-size-3">{{ currentProduct.name }} id: {{ currentProduct.id }}</div>
                    <p class="description has-text-weight-bold">Beschreibung</p>
                <div v-if="currentProduct.description" class="is-size-6">
                    <span v-html="currentProduct.description"/>
                </div>
                <p class="description has-text-weight-bold">Montagehinweis</p>
                <div v-if="currentProduct.short_description" class="is-size-6">
                    <span v-html="currentProduct.short_description"/>
                </div>
            </div>
            <div class="column is-4 product-image is-centered has-image">
                <div class="prod-image" v-if="currentProduct.images[0]"><img :src="currentProduct.images[0].src"/></div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4 is-offset-8 is-centered">
                <div class="has-text-weight-bold is-size-5 product-files" :class="[(currentProduct.drawingTable || currentProduct.approvalsTable  ? 'has-text-primary is-clickable' : 'is-disabled')]" @click="toggleSubItens"><span class="file-button"></span> Technische Daten</div>
                <div class="sub-menu" v-if="subItens">
                    <div class="has-text-weight-bold is-size-5 product-files" :class="[(currentProduct.drawingTable ? 'has-text-primary is-clickable' : 'is-disabled')]" @click="info_modal_drawingTable = true"><span class="file-button"></span> Zeichnung</div>
                    <drawingTable v-if="info_modal_drawingTable && currentProduct.drawingTable" @close="info_modal_drawingTable = false" />
                    <div class="has-text-weight-bold is-size-5 product-files" :class="[(currentProduct.approvalDrawing ? 'has-text-primary is-clickable' : 'is-disabled')]" @click="info_modal_approvalsTable = true"> <span class="file-button"></span> Zulassungen</div>
                    <approvalsTable v-if="info_modal_approvalsTable && currentProduct.approvalDrawing" @close="info_modal_approvalsTable = false" />
                </div>
                <div class="has-text-weight-bold is-size-5 product-files" :class="[(currentProduct.preDrillingTable ? 'has-text-primary is-clickable' : 'is-disabled')]" @click="info_modal_preDrillingTable = true, subItens = false"><span class="file-button"></span> <span> Vorbohrtabelle ansehen</span> </div>
                <preDrillingTable v-if="info_modal_preDrillingTable && currentProduct.preDrillingTable" @close="info_modal_preDrillingTable = false" />
            </div>
        </div>
        <FilterTab
            @setDichtScheibeFilter="setDichtScheibeFilter"
        />
        <div class="table-information">
            <table class="table is-fullwidth is-bordered is-striped list-information" v-if="currentProduct.variations && currentProduct.variations.length > 0">
                <thead>
                    <th class="has-text-centered is-vcentered" width="300px"><p class="is-disabled">Bezeichnung</p></th>
                    <th class="has-text-centered is-vcentered"><p class="is-disabled">Artikelnr.</p></th>
                    <th class="has-text-centered is-clickable is-vcentered" :class="[(sort_by === 'l' ? 'has-text-danger' : '')]" @click="setSorting('l')" v-if="optionFor(firstVariation, 'l')">
                        <span v-if="sort_by === 'l'">
                            <span v-if="this.sort_order === 'ASC'"><icon-filter-numeric-up /></span>
                            <span v-else><icon-filter-numeric-down /></span>
                        </span>
                        <icon-filter v-if="sort_by !== 'l'"/>
                        L[mm]
                    </th>
                     <th class="has-text-centered is-clickable is-vcentered" :class="[(sort_by === 'l1' ? 'has-text-danger' : '')]" @click="setSorting('l1')" v-if="optionFor(firstVariation, 'l1')">
                        <span v-if="sort_by === 'l1'">
                            <span v-if="this.sort_order === 'ASC'"><icon-filter-numeric-up /></span>
                            <span v-else><icon-filter-numeric-down /></span>
                        </span>
                        <icon-filter v-if="sort_by !== 'l1'"/>
                        L1[mm]
                    </th>
                    <th class="has-text-centered is-clickable is-vcentered" :class="[(sort_by === 'fl' ? 'has-text-danger' : '')]" v-if="optionFor(firstVariation, 'fl')">
                        <span v-if="sort_by === 'fl'">
                            <span v-if="this.sort_order === 'ASC'"><icon-filter-numeric-up /></span>
                            <span v-else><icon-filter-numeric-down /></span>
                        </span>
                        <icon-filter v-if="sort_by !== 'fl'"/>
                        FL[mm]
                    </th>
                    <th class="has-text-centered is-vcentered"  v-if="optionFor(firstVariation, 'holz-uk')">
                        <p class="is-disabled">Holz KB min-max</p>
                    </th>
                    <th class="has-text-centered is-vcentered" v-if="optionFor(firstVariation, 'stahl-uk')">
                        <p class="is-disabled">Stahl KB min-max</p>
                    </th>
                    <th class="has-text-centered is-clickable is-vcentered" :class="[(sort_by === 'gewindeläng' ? 'has-text-danger' : '')]" @click="setSorting('gewindeläng')" v-if="optionFor(firstVariation, 'gewindeläng')">
                        <span v-if="sort_by === 'gewindeläng'">
                            <span v-if="this.sort_order === 'ASC'"><icon-filter-numeric-up /></span>
                            <span v-else><icon-filter-numeric-down /></span>
                        </span>
                        <icon-filter v-if="sort_by !== 'gewindeläng'"/>
                        Gewindelänge 
                    </th>
                    <th class="has-text-centered is-clickable is-vcentered" :class="[(sort_by === 'klemmbereich' ? 'has-text-danger' : '')]" @click="setSorting('klemmbereich')" v-if="optionFor(firstVariation, 'klemmbereich')">
                        <span v-if="sort_by === 'klemmbereich'">
                            <span v-if="this.sort_order === 'ASC'"><icon-filter-numeric-up /></span>
                            <span v-else><icon-filter-numeric-down /></span>
                        </span>
                        <icon-filter v-if="sort_by !== 'klemmbereich'"/>
                        Klemmbereich
                    </th>
                    <th class="has-text-centered is-vcentered" v-if="optionFor(firstVariation, 'bohrleistung')">
                       <p class="is-disabled">Bohrleistung[mm]</p>
                    </th>
                    <th class="has-text-centered is-vcentered"  v-if="optionFor(firstVariation, 'dicht-scheibe')">
                        <p class="is-disabled">Dichtscheibe[mm]</p>
                    </th>
                    <th class="has-text-centered is-vcentered"><p class="is-disabled">Anzahl (Stk.)</p></th>
                    
                    <th class="has-text-centered is-vcentered view-control">
                        <p class="is-disabled">{{leftItems}} Artikel gefunden</p>
                    </th>
                </thead>
                <tbody class="list-information">
                    <tr class="list" v-for="(variation, index) in variationsFilteredOne" :key="index">
                        <td width="250px" class="has-text-centered is-vcentered">{{ variation.name }} <span v-if="variation['artikelArt'] === 'sonder-artikel'" class="special-article" >S</span></td>
                        <td class="has-text-centered is-vcentered">{{ variation.sku }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['l']">{{ variation['l'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['l1']">{{ variation['l1'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['fl']">{{ variation['fl'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['holz-uk']">{{ variation['holz-uk'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['stahl-uk']">{{ variation['stahl-uk'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['gewindeläng']">{{ variation['gewindeläng'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['klemmbereich']">{{ variation['klemmbereich'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['bohrleistung']">{{ variation['bohrleistung'] }}</td>
                        <td class="has-text-centered is-vcentered" v-if="variation['dicht-scheibe']">{{ variation['dicht-scheibe'] }}</td>
                        <td width="200px">
                            <QuantitySelect class="is-vcentered"
                                :variation-id="variation.id"
                                @setQuantity="setQuantity"
                            />
                        </td>
                        <td class="has-text-centered is-vcentered">
                            <button class="button is-primary is-uppercase add-button" @click="addToCart(variation), toast()">
                                <span>Hinzufügen</span>
                            </button>
                            <span v-if="amountInCart(variation.id)" class="circle">{{ amountInCart(variation.id) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import QuantitySelect from '@/components/QuantitySelect'
import drawingTable from '@/components/modals/drawingTable'
import preDrillingTable from '@/components/modals/preDrillingTable'
import approvalsTable from '@/components/modals/approvalsTable'
import FilterTab from '@/components/FilterTab'
import IconFilter from '@/components/Icons/IconFilter.vue'

import IconFilterNumericDown from '@/components/Icons/IconFilterNumericDown.vue'
import IconFilterNumericUp from '@/components/Icons/IconFilterNumericUp.vue'
import { createToast } from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'
const _ = require('lodash')
export default {
    components: { QuantitySelect, FilterTab, drawingTable, preDrillingTable, IconFilter, IconFilterNumericDown, IconFilterNumericUp, approvalsTable },
    setup () {
        const toast = () => {    
        createToast('Produkt hinzugefügt!',
            {
            type: 'success',
            transition: 'zoom',
            position: 'top-center',
            timeout: 1500,
            showIcon: true,
            toastBackgroundColor: '#20A64B'
            })
        }
    return { toast }
    },
    data () {
        return {
            sort_by: 'name',
            sort_order: 'ASC',
            info_modal_drawingTable: false,
            info_modal_preDrillingTable: false,
            info_modal_approvalsTable: false,
            totalItens: '',
            dichtScheibeFilterValue: null,
            subItens: false
        }
    },
    mounted () {
        this.showTotalItems()
    },
    computed: {
        variationsFilteredOne() {
            if (this.dichtScheibeFilterValue) {
                const filtered = this.variations.filter(item => item['dicht-scheibe'] === this.dichtScheibeFilterValue)
                return filtered
            }
            return this.variations
        },
        currentStep: {
            set (val) {
                this.$store.commit('setCurrentStep', val)
            },
            get () {
                return this.$store.state.currentStep
            }
        },
        currentProduct: {
            set (val) {
                this.$store.commit('setCurrentProduct', val)
            },
            get () {
                return this.$store.state.currentProduct
            }
        },
        setPageSize() {
            return this.pageSize
        },
        categories () {
            return this.$store.state.categories
        },
        cart () {
            return this.$store.state.cart
        },
        categoryUnterkonstruktion () {
            return this.categories.filter(cat => cat.parent === this.categoryIdUnterkonstruktion)
        },
        categoryMaterial () {
            return this.categories.filter(cat => cat.parent === this.categoryIdMaterial)
        },
        catIdSchraubenart () {
            return this.$store.state.catIdSchraubenart
        },
        categorySchraubenart () {
            return this.categories.find(cat => cat.id === this.catIdSchraubenart)
        },
        // is indicator for what columns in the table are needed
        firstVariation () {
            return this.currentProduct.variations[0]
        },
        variations () {
            return this.currentProduct.variations.map(v => (
                    {
                        ...v,
                        'quantity': 100,
                        'l': parseInt(this.optionFor(v, 'l')),
                        'l1': parseInt(this.optionFor(v, 'l1')),
                        'fl': parseInt(this.optionFor(v, 'fl')),
                        'stahl-uk': this.optionFor(v, 'stahl-uk'),
                        'holz-uk': this.optionFor(v, 'holz-uk'),
                        'gewindeläng': this.optionFor(v, 'gewindeläng'),
                        'klemmbereich': this.optionFor(v, 'klemmbereich'),
                        'bohrleistung': this.optionFor(v, 'bohrleistung'),
                        'dicht-scheibe': this.optionFor(v, 'dicht-scheibe'),
                        'artikelArt': this.optionFor(v, 'artikelArt')
                    }
                )
            ).sort((a, b) => {
                if (this.sort_order === 'ASC') {
                    if (Number.isInteger(a[this.sort_by])) {
                        return a[this.sort_by] - b[this.sort_by]
                    }
                    else if 
                        (a[this.sort_by].split('-').length === 2) {
                        return a[this.sort_by].split('-')[0] - b[this.sort_by].split('-')[0]
                    } else {
                        return a[this.sort_by].localeCompare(b[this.sort_by])
                    }
                } else {
                    if (Number.isInteger(a[this.sort_by])) {
                        return b[this.sort_by] - a[this.sort_by]
                    } else if 
                        (a[this.sort_by].split('-').length === 2) {
                        return b[this.sort_by].split('-')[0] - a[this.sort_by].split('-')[0]
                    } else {
                        return b[this.sort_by].localeCompare(a[this.sort_by])
                    }
                }
            })
        },
        leftItems () {
           return this.variationsFilteredOne.length
        },
    },
    methods: {
        optionFor (variation, attributeName) {
            const foundOption = variation.attributes.find(attr => attr.name === attributeName)
            if (foundOption) {
                return foundOption.option
            } else {
                return null
            }
        },
        setQuantity (val) {
            let variation = this.variations.find(variation => variation.id === val.variationId)
            variation.quantity = val.quantity
        },
        addToCart (variation) {
            const clone = _.clone(variation)
            this.$store.commit('createOrUpdateLineItemInCart', clone)
        },
        restartConfigurator () {
            this.currentProduct = null
            this.currentStep = 'Unterkonstruktion'
        },
        setSorting (name) {
            if (this.sort_order === 'ASC') {
                this.sort_order = 'DESC'
            } else {
                this.sort_order = 'ASC'
            }
            this.sort_by = name
        },
        showTotalItems () {
            this.totalItens = this.variationsFilteredOne.length
        },
        scrollToTop () { 
            const scrollMe = this.$refs.top
            if (scrollMe) {
                scrollMe.scrollIntoView({ block: 'start', behavior: 'smooth'});
            }
        },
        amountInCart (variationId) {
            const item = this.cart.find(lineItem => lineItem.id === variationId)
            if (item) {
                return item.quantity
            } else {
                return 0
            }
        },
        setDichtScheibeFilter (val) {
            this.dichtScheibeFilterValue = val
        },
        toggleSubItens () {
            if(this.currentProduct.drawingTable || this.currentProduct.approvalsTable) {
                this.subItens = !this.subItens
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import "../assets/sass/main.sass"

.list
 background-color: $grey-light
 
.table-information
    background-color: white

.product-image
    background-color: $grey-light
    vertical-align: middle

.has-image
  align-items: center
  padding: 15px 0 15px 0

.product-files
    margin: 20px 0 20px 0

.description
    margin-top: 30px

.is-disabled
    color: $grey

.view-control
    display: block

.circle
    font-size: 12px
    margin-top: -10px
    margin-left: -15px
    color: $primary
    padding-top: 2px
    width: 30px
    height: 30px
    border-radius: 50%
    align-items: center
    background-color: $grey-lighter
    position: absolute !important
    font-weight: 700
    border-color: $grey-light
    border-style: solid

.file-button
   display: inline-flex
   width: 22px
   height: 22px
   border: 2px solid
   transform: scale(var(--ggs,.8))
   border-radius: 22px
.file-button::after,
.file-button::before
   content: ""
   display: inline-flex
   box-sizing: border-box
   position: absolute
   width: 10px
   height: 2px
   background: currentColor
   border-radius: 5px
   top: 8px
   left: 4px

.file-button::after
   width: 2px
   height: 10px
   top: 4px
   left: 8px

.special-article
    font-size: 12px
    margin-left: 10px
    color: white
    padding-top: 2px
    width: 30px
    height: 30px
    border-radius: 50%
    align-items: center
    background-color: $primary
    position: absolute !important
    font-weight: 700
    border-color: $grey-light
    border-style: solid
.sub-menu
    padding-left: 30px
    transition: 0.5s

.approval-image
    width: 200px

.prod-image
    padding: 20px 10px 20px 10px

</style>